<template>
	<div
		class="
			relative flex flex-1 overflow-hidden bg-primary
			[--auth-pattern-dash:color-mix(in_oklch,var(--color-primary)_30%,white)]
			[--auth-pattern-face:color-mix(in_oklch,var(--color-primary)_90%,white)]
		"
	>
		<AuthAnimatedBackground />
	</div>
</template>
